/**
 * EM PDP: move complementary products under gallery on desktop
 */
(() => {
  const MQ = window.matchMedia("(min-width: 1000px)");
  let origParent = null;
  let origNext = null;

  const move = () => {
    const product = document.querySelector(".product");
    if (!product) return;

    const gallery = product.querySelector(":scope > .product-gallery");
    const block = product.querySelector('[data-block-type="associated-products"]');
    if (!gallery || !block) return;

    if (!origParent) {
      origParent = block.parentElement;
      origNext = block.nextElementSibling;
    }

    if (MQ.matches) {
      if (block.parentElement !== product || block.previousElementSibling !== gallery) {
        gallery.after(block);
      }
      product.classList.add("em-product--complementary-left");
    } else {
      product.classList.remove("em-product--complementary-left");
      if (origParent && block.parentElement !== origParent) {
        if (origNext && origNext.parentElement === origParent) {
          origParent.insertBefore(block, origNext);
        } else {
          origParent.appendChild(block);
        }
      }
    }
  };

  const start = () => {
    move();
    const product = document.querySelector(".product");
    if (!product) return;
    const observer = new MutationObserver(() => move());
    observer.observe(product, { childList: true, subtree: true });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }

  MQ.addEventListener("change", move);
})();
